import React from "react";
import useStore from "utils/reportStore";
import IeltsReport from "components/Report/IELTS";
import ToeflReport from "components/Report/TOEFL";

import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useLoading, useSnackbar } from "contexts";
import {
    getMockAttemptById, getMockAttemptByToken
} from "services/attemptService";
import { detectMobileDevice } from "utils";
import { Box } from "@mui/material";

const MenuItems = [
    { title: "Home", link: "/home" },
    { title: "FAQs", link: "/home/faq" },
];

export default function Report() {
    const loading = useLoading();
    const snackbar = useSnackbar();
    const navigate = useNavigate();

    const [searchParams] = useSearchParams();
    const { type } = useParams();

    const setAttempt = useStore((state) => state.setAttempt);

    const isApiRequest = searchParams.get('api');

    React.useEffect(() => {
        (async () => {
            try {
                loading.show();

                const isMobile = detectMobileDevice();
                if (!isMobile) {

                    const accessToken = searchParams.get('at');
                    const attemptId = searchParams.get('aid');

                    let attempt;


                    if (accessToken) {
                        attempt = await getMockAttemptByToken(accessToken);
                    } else if (true) {
                        attempt = await getMockAttemptById(attemptId)
                    } else {
                        throw new Error("Invalid link");
                    }

                    // if (accessToken) {
                    //     attempt = await getMockAttemptByToken(accessToken);
                    // } else if (Session.isLoggedIn()) {
                    //     attempt = await getMockAttemptById(attemptId)
                    // } else {
                    //     throw new Error("Invalid link");
                    // }

                    if (!attempt) {
                        throw new Error('Attempt not found!');
                    }

                    setAttempt(attempt);
                } else {
                    navigate('/unsupported-device?from=report');
                }

            } catch (error) {
                console.error(error);

                snackbar.error("Uh Oh! Something went wrong!", false);
                if (!isApiRequest) navigate("/error");
            } finally {
                loading.hide();
            }
        })();
    }, []);

    return (
        <Box style={{ height: '100vh', padding: '10px 0px 0px 0px' }}>
            {(type === 'toefl') ? <ToeflReport /> : null}
            {(type === 'ielts') ? <IeltsReport /> : null}
        </Box>
    );
}